import { Box } from "@mui/material";
import { useEffect, useState } from "react";

const AlertBanner = (props) => {
  const { alertMessage = "" } = props;

  const [showNotice, setShowNotice] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setShowNotice(false), 3000);
    return () => clearTimeout(timer);
  }, []);

  if (!showNotice) return null;

  return (
    <Box
      sx={{
        position: "absolute",
        top: "10px",
        left: "10px",
        zIndex: 10,
        background: "rgba(0, 0, 0, 0.7)",
        color: "white",
        padding: "8px 12px",
        borderRadius: "4px",
        fontSize: "12px",
        fontWeight: "bold",
        maxWidth: "200px",
      }}
    >
      {alertMessage}
    </Box>
  );
};

export default AlertBanner;
